export default {"src":"/_next/static/media/3D.ed0a4d74.svg","height":30,"width":20};